import React from 'react';
import { Upload } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DownloadIcon from '@mui/icons-material/Download';
import SearchIcon from '@mui/icons-material/Search';
import { Box, CircularProgress, InputAdornment } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AppButton from '../../../../components/ui/AppButton';
import AppInput from '../../../../components/ui/AppInput';

const SearchFilter = ({ search, handleSearch, handleExport, isExporting }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
        [theme.breakpoints.up('sm')]: {
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'space-between',
        },
      })}
    >
      <Box sx={{ maxWidth: 400, width: '100%' }}>
        <AppInput
          placeholder="ค้นหารหัสบริษัท, ชื่อบริษัท"
          value={search}
          onChange={handleSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: '#004B61' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: '4px',
        }}
      >
        <AppButton variant="infoDark" onClick={() => navigate('/admin/company/add')}>
          <AddIcon sx={{ fontSize: '1rem', display: 'inline-block', marginRight: '5px' }} />
          Add Company
        </AppButton>
        <AppButton variant="primary" onClick={() => navigate('/admin/import-point')}>
          <DownloadIcon sx={{ fontSize: '1rem', display: 'inline-block', marginRight: '5px' }} />
          Import Point
        </AppButton>
        <AppButton variant="brand" onClick={() => navigate('/admin/import')}>
          <DownloadIcon sx={{ fontSize: '1rem', display: 'inline-block', marginRight: '5px' }} />
          Import Company
        </AppButton>
        <AppButton variant="dangerStrong" onClick={handleExport} disabled={isExporting}>
          {isExporting ? (
            <CircularProgress
              size={14}
              sx={{ color: '#333', display: 'inline-block', marginRight: '5px' }}
            />
          ) : (
            <Upload sx={{ fontSize: '1rem', display: 'inline-block', marginRight: '5px' }} />
          )}
          Export Excel
        </AppButton>
      </Box>
    </Box>
  );
};
export default React.memo(SearchFilter);
